import React, { useState } from 'react';
import DemoVideo from './DemoVideo';
// import OperatorPricingSection from './OperatorPricingSection'; // COMMENTED OUT FOR LEAD GEN

const LandingPage: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showBookingForm, setShowBookingForm] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleBookCall = () => {
    setShowBookingForm(true);
    // Scroll to form
    setTimeout(() => {
      document.getElementById('booking-form')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <>
      {/* Header */}
      <div className="header">
        <div className="container">
          <div className="nav-brand">
            <a href="/" style={{ textDecoration: 'none', color: 'inherit' }}>
              <h2 className="logo">Meistro Asistentas</h2>
              <p className="tagline">Jūsų dirbtinio intelekto asistentas</p>
            </a>
          </div>
          {/* Mobile Menu Button */}
          <button
            className="mobile-menu-toggle"
            onClick={toggleMobileMenu}
            style={{
              display: 'none',
              background: 'none',
              border: 'none',
              fontSize: '1.5rem',
              color: '#000042',
              cursor: 'pointer',
              padding: '0.5rem'
            }}
          >
            {isMobileMenuOpen ? '✕' : '☰'}
          </button>

          {/* Navigation Menu */}
          <nav className={`nav-menu ${isMobileMenuOpen ? 'nav-menu-open' : ''}`}>
            <ul>
              <li><a href="#demo">Demonstracija</a></li>
              <li><a href="#benefits">Privalumai</a></li>
              <li><a href="#contact">Kontaktai</a></li>
              {/* COMMENTED OUT FOR LEAD GEN
              <li><a href="/registracija" className="btn-secondary" style={{ color: '#000042', borderColor: '#000042' }}>Registruotis</a></li>
              <li><a href="/prisijungti" className="btn-primary" style={{ color: 'white' }}>Prisijungti</a></li>
              */}
              <li>
                <button
                  onClick={handleBookCall}
                  className="btn-primary"
                  style={{
                    color: 'white',
                    padding: '12px 24px',
                    borderRadius: '8px',
                    border: 'none',
                    cursor: 'pointer',
                    fontWeight: '600'
                  }}
                >
                  Suplanuoti skambutį
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      {/* Hero Section */}
      <section className="hero" id="demo">
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h1 className="hero-title" style={{ marginBottom: '1rem' }}>
              AI asistentas santechnikams, elektrikams, dažytojams ir kitiems meistrams
            </h1>
            <p className="hero-subtitle" style={{ maxWidth: '800px', margin: '0 auto 2rem' }}>
              Atsakykite į kiekvieną skambutį 24/7 - net kai dirbate, vairuojate ar poilsiaujate.
              Jūsų AI asistentas kalba lietuviškai ir siunčia detalizuotas ataskaitas tiesiai į el. paštą.
            </p>
          </div>

          {/* Main Video - YouTube Embed (placeholder) */}
          <div style={{
            maxWidth: '900px',
            margin: '0 auto 3rem',
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
          }}>
            {/* TODO: Replace with actual video URL */}
            <div style={{
              position: 'relative',
              paddingBottom: '56.25%', // 16:9 aspect ratio
              height: 0,
              overflow: 'hidden'
            }}>
              <iframe
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }}
                src="https://www.youtube.com/embed/rNt2bP555Qs"
                title="Meistro Asistentas Demo"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>

          <div className="hero-stats" style={{ justifyContent: 'center' }}>
            <div className="stat-item">
              <span className="stat-number">&lt;2s</span>
              <span className="stat-label">Atsakymo laikas</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">24/7</span>
              <span className="stat-label">Veikia visą parą</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">100%</span>
              <span className="stat-label">Lietuvių kalba</span>
            </div>
          </div>

          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <button onClick={handleBookCall} className="btn-cta" style={{ fontSize: '1.2rem', padding: '18px 40px' }}>
              Suplanuoti skambutį
            </button>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works" style={{
        padding: '5rem 2rem',
        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)'
      }}>
        <div className="container">
          <div className="section-header">
            <h2 className="section-title" style={{ color: '#000042' }}>Kaip tai veikia?</h2>
            <p className="section-subtitle" style={{ color: '#666' }}>
              Paprastas procesas - maksimalūs rezultatai
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '2rem',
            marginTop: '3rem',
            maxWidth: '1200px',
            margin: '3rem auto 0'
          }}>
            {/* Step 1 */}
            <div style={{
              background: 'white',
              padding: '2rem',
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
              textAlign: 'center',
              position: 'relative'
            }}>
              <div style={{
                fontSize: '3rem',
                marginBottom: '1rem'
              }}>📞</div>
              <h3 style={{ color: '#000042', marginBottom: '1rem', fontSize: '1.3rem' }}>1. Klientas skambina</h3>
              <p style={{ color: '#666', lineHeight: '1.8', fontSize: '0.95rem' }}>
                Klientas suranda jūsų numerį ir paskambina. AI asistentas atsako per 2 sekundes.
              </p>
            </div>

            {/* Arrow */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '2rem',
              color: '#0066ff'
            }}>
              →
            </div>

            {/* Step 2 */}
            <div style={{
              background: 'white',
              padding: '2rem',
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
              textAlign: 'center'
            }}>
              <div style={{
                fontSize: '3rem',
                marginBottom: '1rem'
              }}>🤖</div>
              <h3 style={{ color: '#000042', marginBottom: '1rem', fontSize: '1.3rem' }}>2. AI atsako ir klausia</h3>
              <p style={{ color: '#666', lineHeight: '1.8', fontSize: '0.95rem' }}>
                Asistentas pasikalba lietuviškai, sužino vardą, telefono numerį ir darbo detales.
              </p>
            </div>

            {/* Arrow */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '2rem',
              color: '#0066ff'
            }}>
              →
            </div>

            {/* Step 3 */}
            <div style={{
              background: 'white',
              padding: '2rem',
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
              textAlign: 'center'
            }}>
              <div style={{
                fontSize: '3rem',
                marginBottom: '1rem'
              }}>📧</div>
              <h3 style={{ color: '#000042', marginBottom: '1rem', fontSize: '1.3rem' }}>3. Jūs gaunat el. laišką</h3>
              <p style={{ color: '#666', lineHeight: '1.8', fontSize: '0.95rem' }}>
                Per 1 minutę jūsų el. pašte atsiranda visa informacija su mygtuku "Perskambinti".
              </p>
            </div>
          </div>

          {/* Email Preview */}
          <div style={{
            marginTop: '4rem',
            maxWidth: '600px',
            margin: '4rem auto 0',
            background: 'white',
            border: '1px solid #e0e0e0',
            overflow: 'hidden',
            boxShadow: '0 8px 24px rgba(0,0,0,0.15)'
          }}>
            <div style={{
              background: '#000042',
              color: 'white',
              padding: '30px',
              textAlign: 'center'
            }}>
              <h3 style={{ margin: 0, fontSize: '24px', fontWeight: 600, letterSpacing: '-0.5px' }}>Pokalbio Santrauka</h3>
              <p style={{ margin: '10px 0 0 0', fontSize: '14px', opacity: 0.9 }}>2025-01-24 - AI Asistentas</p>
            </div>

            <div style={{ padding: '30px' }}>
              <div style={{ fontSize: '18px', fontWeight: 600, marginBottom: '20px', color: '#000042' }}>
                Naujas pokalbis užbaigtas
              </div>

              <div style={{ fontSize: '14px', lineHeight: 1.7, marginBottom: '20px', color: '#555555' }}>
                Jūsų AI asistentas užbaigė pokalbį su potencialiu klientu. Štai visa informacija apie pokalbį.
              </div>

              <div style={{
                background: '#f8f8f8',
                border: '1px solid #e0e0e0',
                padding: '20px',
                margin: '20px 0'
              }}>
                <h3 style={{ marginTop: 0, color: '#000042', fontSize: '16px' }}>Kontaktinė informacija</h3>

                <div style={{ margin: '10px 0', fontSize: '14px', color: '#555555' }}>
                  <strong style={{ color: '#333333' }}>Vardas:</strong> Jonas Petraitis
                </div>

                <div style={{ margin: '10px 0', fontSize: '14px', color: '#555555' }}>
                  <strong style={{ color: '#333333' }}>Telefonas:</strong> +370 612 34567
                </div>

                <div style={{ margin: '10px 0', fontSize: '14px', color: '#555555' }}>
                  <strong style={{ color: '#333333' }}>Adresas:</strong> Vilnius, Žirmūnai
                </div>

                <div style={{ margin: '10px 0', fontSize: '14px', color: '#555555' }}>
                  <strong style={{ color: '#333333' }}>Paslaugos tipas:</strong> Santechnikos darbai
                </div>

                <div style={{ margin: '10px 0', fontSize: '14px', color: '#555555' }}>
                  <strong style={{ color: '#333333' }}>Pokalbio trukmė:</strong> 2m 15s
                </div>
              </div>

              <div style={{
                background: '#f8f8f8',
                padding: '15px',
                borderLeft: '3px solid #000042',
                margin: '20px 0'
              }}>
                <strong style={{ color: '#333333' }}>Pokalbio santrauka:</strong><br />
                <div style={{ marginTop: '10px', color: '#555555', fontSize: '14px', lineHeight: 1.7 }}>
                  Klientas Jonas praneša apie vandens vamzdžių problemas vonios kambaryje. Situacija neskubi, tačiau reikalingas profesionalus įvertinimas. Klientas gyvena Žirmūnų rajone ir gali susitikti šią savaitę.
                </div>
              </div>

              <div style={{
                background: '#f8f8f8',
                padding: '25px',
                margin: '20px 0',
                textAlign: 'center',
                border: '1px solid #e0e0e0'
              }}>
                <p style={{
                  margin: '0 0 10px 0',
                  fontSize: '12px',
                  fontWeight: 600,
                  color: '#666666',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px'
                }}>
                  Susisiekite su klientu
                </p>
                <a href="#" style={{
                  display: 'inline-block',
                  background: '#000042',
                  color: 'white',
                  padding: '12px 30px',
                  textDecoration: 'none',
                  fontWeight: 600,
                  fontSize: '14px',
                  textAlign: 'center'
                }}>
                  Perskambinti
                </a>
              </div>
            </div>

            <div style={{
              background: '#f8f8f8',
              color: '#666666',
              padding: '20px',
              textAlign: 'center',
              borderTop: '1px solid #e0e0e0',
              fontSize: '12px'
            }}>
              <p style={{ margin: '5px 0', fontWeight: 600, color: '#000042' }}>Meistro Asistentas</p>
              <p style={{ margin: '5px 0' }}>
                <a href="mailto:atsiliepsiu@gmail.com" style={{ color: '#000042', textDecoration: 'none' }}>atsiliepsiu@gmail.com</a>
              </p>
            </div>
          </div>

          <div style={{ textAlign: 'center', marginTop: '3rem' }}>
            <p style={{ color: '#666', fontSize: '0.95rem', fontStyle: 'italic', marginBottom: '2rem' }}>
              ↑ Taip atrodo el. laiškas, kurį gaunate po kiekvieno skambučio
            </p>
            <a
              href="tel:+37052002623"
              className="btn-cta"
              style={{
                display: 'inline-block',
                fontSize: '1.2rem',
                padding: '18px 40px',
                background: '#0066ff',
                color: 'white',
                border: 'none',
                textDecoration: 'none',
                fontWeight: 'bold',
                cursor: 'pointer',
                borderRadius: '8px'
              }}
            >
              Išbandykite dabar: +370 (5) 200 2623
            </a>
          </div>
        </div>
      </section>

      {/* Pricing Tiers Section */}
      <section style={{
        padding: '5rem 2rem',
        background: 'white'
      }}>
        <div className="container">
          <div className="section-header">
            <h2 className="section-title" style={{ color: '#000042' }}>Kainos</h2>
            <p className="section-subtitle" style={{ color: '#666' }}>
              Pasirinkite planą, kuris atitinka jūsų verslo poreikius
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '2rem',
            maxWidth: '1200px',
            margin: '3rem auto 0'
          }}>
            {/* Starter Plan */}
            <div style={{
              background: 'white',
              border: '2px solid #e0e0e0',
              borderRadius: '16px',
              padding: '2.5rem',
              textAlign: 'center',
              transition: 'all 0.3s ease',
              position: 'relative'
            }}>
              <h3 style={{
                color: '#000042',
                fontSize: '1.8rem',
                marginBottom: '1rem',
                fontWeight: '700'
              }}>Pradžiai</h3>

              <div style={{
                fontSize: '3rem',
                fontWeight: '700',
                color: '#0066ff',
                marginBottom: '0.5rem'
              }}>
                €67
                <span style={{ fontSize: '1.2rem', color: '#666', fontWeight: '400' }}>/mėn</span>
              </div>

              <div style={{
                background: '#f8f9fa',
                padding: '1.5rem',
                borderRadius: '12px',
                margin: '1.5rem 0'
              }}>
                <div style={{
                  fontSize: '1rem',
                  color: '#666',
                  marginBottom: '0.8rem'
                }}>
                  <strong style={{ color: '#000042' }}>Minutės:</strong> 100 per mėnesį
                </div>
                <div style={{
                  fontSize: '1rem',
                  color: '#666',
                  marginBottom: '0.8rem'
                }}>
                  <strong style={{ color: '#000042' }}>Įdiegimas:</strong> €47 (vienkartinis)
                </div>
                <div style={{
                  fontSize: '0.9rem',
                  color: '#666',
                  fontWeight: '500',
                  padding: '0.8rem',
                  background: '#f8f9fa',
                  borderRadius: '8px',
                  marginTop: '1rem'
                }}>
                  Idealus vienam meistrui
                </div>
              </div>

              <button
                onClick={handleBookCall}
                style={{
                  width: '100%',
                  background: '#000042',
                  color: 'white',
                  padding: '14px 28px',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '1.1rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = '#0066ff'}
                onMouseLeave={(e) => e.currentTarget.style.background = '#000042'}
              >
                Pradėti
              </button>
            </div>

            {/* Growth Plan - Featured */}
            <div style={{
              background: 'linear-gradient(135deg, #0066ff 0%, #0052cc 100%)',
              border: '3px solid #0066ff',
              borderRadius: '16px',
              padding: '2.5rem',
              textAlign: 'center',
              position: 'relative',
              transform: 'scale(1.05)',
              boxShadow: '0 20px 40px rgba(0, 102, 255, 0.3)'
            }}>
              <div style={{
                position: 'absolute',
                top: '-15px',
                left: '50%',
                transform: 'translateX(-50%)',
                background: '#22c55e',
                color: 'white',
                padding: '6px 20px',
                borderRadius: '20px',
                fontSize: '0.85rem',
                fontWeight: '700',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}>
                Populiariausias
              </div>

              <h3 style={{
                color: 'white',
                fontSize: '1.8rem',
                marginBottom: '1rem',
                fontWeight: '700'
              }}>Augimui</h3>

              <div style={{
                fontSize: '3rem',
                fontWeight: '700',
                color: 'white',
                marginBottom: '0.5rem'
              }}>
                €127
                <span style={{ fontSize: '1.2rem', opacity: 0.9, fontWeight: '400' }}>/mėn</span>
              </div>

              <div style={{
                background: 'rgba(255, 255, 255, 0.15)',
                padding: '1.5rem',
                borderRadius: '12px',
                margin: '1.5rem 0',
                backdropFilter: 'blur(10px)'
              }}>
                <div style={{
                  fontSize: '1rem',
                  color: 'white',
                  marginBottom: '0.8rem'
                }}>
                  <strong>Minutės:</strong> 300 per mėnesį
                </div>
                <div style={{
                  fontSize: '1rem',
                  color: 'white',
                  marginBottom: '0.8rem'
                }}>
                  <strong>Įdiegimas:</strong> €47 (vienkartinis)
                </div>
                <div style={{
                  fontSize: '0.9rem',
                  color: 'white',
                  fontWeight: '500',
                  padding: '0.8rem',
                  background: 'rgba(255, 255, 255, 0.2)',
                  borderRadius: '8px',
                  marginTop: '1rem'
                }}>
                  Meistrams su 2-5 klientais per dieną
                </div>
              </div>

              <button
                onClick={handleBookCall}
                style={{
                  width: '100%',
                  background: 'white',
                  color: '#0066ff',
                  padding: '14px 28px',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '1.1rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#f0f9ff';
                  e.currentTarget.style.transform = 'scale(1.02)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'white';
                  e.currentTarget.style.transform = 'scale(1)';
                }}
              >
                Pradėti
              </button>
            </div>

            {/* Team Plan */}
            <div style={{
              background: 'white',
              border: '2px solid #e0e0e0',
              borderRadius: '16px',
              padding: '2.5rem',
              textAlign: 'center',
              transition: 'all 0.3s ease',
              position: 'relative'
            }}>
              <h3 style={{
                color: '#000042',
                fontSize: '1.8rem',
                marginBottom: '1rem',
                fontWeight: '700'
              }}>Įmonei</h3>

              <div style={{
                fontSize: '3rem',
                fontWeight: '700',
                color: '#0066ff',
                marginBottom: '0.5rem'
              }}>
                €197
                <span style={{ fontSize: '1.2rem', color: '#666', fontWeight: '400' }}>/mėn</span>
              </div>

              <div style={{
                background: '#f8f9fa',
                padding: '1.5rem',
                borderRadius: '12px',
                margin: '1.5rem 0'
              }}>
                <div style={{
                  fontSize: '1rem',
                  color: '#666',
                  marginBottom: '0.8rem'
                }}>
                  <strong style={{ color: '#000042' }}>Minutės:</strong> 600 per mėnesį
                </div>
                <div style={{
                  fontSize: '1rem',
                  color: '#666',
                  marginBottom: '0.8rem'
                }}>
                  <strong style={{ color: '#000042' }}>Įdiegimas:</strong> €47 (vienkartinis)
                </div>
                <div style={{
                  fontSize: '0.9rem',
                  color: '#666',
                  fontWeight: '500',
                  padding: '0.8rem',
                  background: '#f8f9fa',
                  borderRadius: '8px',
                  marginTop: '1rem'
                }}>
                  Meistrų įmonėms
                </div>
              </div>

              <button
                onClick={handleBookCall}
                style={{
                  width: '100%',
                  background: '#000042',
                  color: 'white',
                  padding: '14px 28px',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '1.1rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = '#0066ff'}
                onMouseLeave={(e) => e.currentTarget.style.background = '#000042'}
              >
                Pradėti
              </button>
            </div>
          </div>

          <div style={{
            textAlign: 'center',
            marginTop: '3rem',
            padding: '2rem',
            background: '#f8f9fa',
            borderRadius: '12px'
          }}>
            <p style={{ color: '#666', fontSize: '0.95rem', marginBottom: '1rem' }}>
              ✓ Galite keisti planą bet kuriuo metu<br />
              ✓ Nėra paslėptų mokesčių
            </p>
          </div>
        </div>
      </section>

      {/* COMMENTED OUT FOR LEAD GEN - Pricing Section
      <OperatorPricingSection
        onGetStarted={async (pkg) => {
          // Check if user is logged in first
          try {
            const response = await fetch('/api/user/auth/status', { credentials: 'include' });
            const data = await response.json();

            if (data.authenticated) {
              // User is logged in, go to dashboard where they can purchase
              window.location.href = '/dashboard';
            } else {
              // User is not logged in, go to registration with package info
              const orderId = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
              window.location.href = `/registracija?minutes=${pkg.minutes}&price=${pkg.price}&orderId=${orderId}`;
            }
          } catch (error) {
            // If auth check fails, go to registration anyway
            const orderId = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
            window.location.href = `/registracija?minutes=${pkg.minutes}&price=${pkg.price}&orderId=${orderId}`;
          }
        }}
      />
      */}

      {/* Use Cases Section */}
      <section className="services" id="use-cases">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Kam tai skirta?</h2>
            <p className="section-subtitle">
              Pritaikyta statybų ir remonto sektoriaus meistrams
            </p>
          </div>

          <div className="grid grid-cols-3">
            {/* Santechnikai */}
            <div className="service-card">
              <div className="service-icon"></div>
              <h4>Santechnikams</h4>
              <p>Avariniai kviečimai, vamzdžių remontas, įrenginių montavimas</p>
              <ul className="service-features">
                <li>Avarinių skambučių priėmimas</li>
                <li>Problemos diagnostika</li>
                <li>Vizitų planavimas</li>
                <li>Kainų pateikimas pagal darbo tipą</li>
              </ul>
            </div>

            {/* Elektrikai */}
            <div className="service-card">
              <div className="service-icon"></div>
              <h4>Elektrikams</h4>
              <p>Elektros montavimas, gedimų šalinimas, sertifikuoti darbai</p>
              <ul className="service-features">
                <li>Skambučių priėmimas 24/7</li>
                <li>Avarinių atvejų registracija</li>
                <li>Darbo grafikų koordinavimas</li>
                <li>Informacija apie sertifikatus</li>
              </ul>
            </div>

            {/* Dažytojai */}
            <div className="service-card">
              <div className="service-icon"></div>
              <h4>Dažytojams</h4>
              <p>Patalpų dažymas, fasadų atnaujinimas, dekoravimas</p>
              <ul className="service-features">
                <li>Užklausų priėmimas</li>
                <li>Kainų skaičiavimas pagal plotą</li>
                <li>Apžiūrų planavimas</li>
                <li>Medžiagų konsultacijos</li>
              </ul>
            </div>

            {/* Staliai */}
            <div className="service-card">
              <div className="service-icon"></div>
              <h4>Staliams</h4>
              <p>Baldų gamyba, medinių konstrukcijų montavimas, restauravimas</p>
              <ul className="service-features">
                <li>Individualių užsakymų priėmimas</li>
                <li>Matavimų koordinavimas</li>
                <li>Medžiagų pasirinkimas</li>
                <li>Terminų derinimas</li>
              </ul>
            </div>

            {/* Stogdengiai */}
            <div className="service-card">
              <div className="service-icon"></div>
              <h4>Stogdengiams</h4>
              <p>Stogų dengimas, remontas, izoliacijos darbai</p>
              <ul className="service-features">
                <li>Apžiūrų planavimas</li>
                <li>Kainų skaičiavimas pagal stogo tipą</li>
                <li>Garantijų informacija</li>
                <li>Sezoninių darbų koordinavimas</li>
              </ul>
            </div>

            {/* Statybininkai */}
            <div className="service-card">
              <div className="service-icon"></div>
              <h4>Statybininkams</h4>
              <p>Bendri statybos darbai, renovacija, apdaila</p>
              <ul className="service-features">
                <li>Projektų užklausų priėmimas</li>
                <li>Darbų apimties įvertinimas</li>
                <li>Susitikimų planavimas</li>
                <li>Įkainių pateikimas</li>
              </ul>
            </div>
          </div>

          <div style={{ textAlign: 'center', marginTop: '3rem' }}>
            <button onClick={handleBookCall} className="btn-cta">
              Suplanuoti demonstracinį skambutį
            </button>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="features" id="benefits">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Kodėl meistrai renkasi AI asistentą?</h2>
            <p className="section-subtitle">
              Profesionalus sprendimas, kuris dirba už jus ir leidžia sutelkti dėmesį į darbą
            </p>
          </div>

          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-icon"></div>
              <h4>Dirbkite ramiai - skambučius atsakys AI</h4>
              <p>Jūs ant stogo, pas klientą ar važiuojate - asistentas atsakys į visus skambučius 24/7. Nė vienas klientas nebus praleistas.</p>
            </div>

            <div className="feature-item">
              <div className="feature-icon"></div>
              <h4>Žino jūsų kainas ir paslaugas</h4>
              <p>Suprogramuojame asistentą pagal jūsų verslą - jis žinos kainas, darbo sritis, darbo valandas ir atsakys profesionaliai.</p>
            </div>

            <div className="feature-item">
              <div className="feature-icon"></div>
              <h4>Visos ataskaitos el. pašte</h4>
              <p>Po kiekvieno skambučio gausite santrauką - kliento vardas, telefonas, darbo aprašymas ir kada jis nori susitikti.</p>
            </div>

            <div className="feature-item">
              <div className="feature-icon"></div>
              <h4>Kalba lietuviškai, angliškai, rusiškai</h4>
              <p>Asistentas automatiškai atpažįsta kalbą ir bendrauja su klientu jo gimtąja kalba. Tarptautiniai klientai - ne problema.</p>
            </div>

            <div className="feature-item">
              <div className="feature-icon"></div>
              <h4>Paleidžiame per 24 valandas</h4>
              <p>Užpildote klausimyną apie savo verslą, o mes suprogramuojame ir paleidžiame asistentą jau rytoj.</p>
            </div>

            <div className="feature-item">
              <div className="feature-icon"></div>
              <h4>Efektyvus sprendimas jūsų verslui</h4>
              <p>Jokių atlyginimų, jokių atostogų, jokių ligų. Dirba visada, kai jums reikia. Tik rezultatai.</p>
            </div>
          </div>
        </div>
      </section>


      {/* CTA & Contact Form Section */}
      <section className="contact" id="contact">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title" style={{ color: 'white' }}>
              Susidomėjote? Susisiekime!
            </h2>
            <p className="section-subtitle" style={{ color: 'rgba(255,255,255,0.9)' }}>
              Užpildykite formą ir mes susisieksime su jumis artimiausiu metu demonstracijai
            </p>
          </div>

          {showBookingForm && (
            <div id="booking-form" style={{
              maxWidth: '900px',
              margin: '2rem auto',
              background: 'white',
              padding: '2rem',
              borderRadius: '12px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
            }}>
              <h3 style={{ marginBottom: '0.5rem', color: '#000042', textAlign: 'center' }}>Suplanuoti demonstracinį skambutį</h3>
              <p style={{ marginBottom: '1.5rem', color: '#666', textAlign: 'center', fontSize: '0.95rem' }}>
                Pasirinkite jums patogų laiką 30 minučių konsultacijai. Aptarsime, kaip AI asistentas gali padėti jūsų verslui augti.
              </p>

              {/* Booking CTA -> Ainora funnel */}
              <div style={{ textAlign: 'center' }}>
                <a
                  href="https://ainora.lt/lt/kontaktai?from=meistro"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-cta"
                  style={{
                    display: 'inline-block',
                    fontSize: '1.2rem',
                    padding: '18px 40px',
                    textDecoration: 'none'
                  }}
                >
                  Pasirinkti laiką
                </a>
              </div>
            </div>
          )}

          {!showBookingForm && (
            <div style={{ textAlign: 'center', marginTop: '3rem' }}>
              <button
                onClick={handleBookCall}
                className="btn-cta"
                style={{ fontSize: '1.2rem', padding: '18px 40px' }}
              >
                Suplanuoti demonstracinį skambutį
              </button>
              <div style={{
                textAlign: 'center',
                marginTop: '2rem',
                color: 'rgba(255,255,255,0.85)',
                fontSize: '0.95rem'
              }}>
                Demonstracija • Jokių įsipareigojimų • Atsakome per 24 val.
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <h4>Meistro Asistentas</h4>
              <p>
                Profesionalus dirbtinio intelekto balso asistentas Lietuvos verslui.
                Automatizuokite skambučius, taupykite laiką ir niekada nepraleisite potencialių klientų.
              </p>
            </div>

            <div className="footer-section">
              <h5>Navigacija</h5>
              <ul>
                <li><a href="#demo">Demonstracija</a></li>
                <li><a href="#use-cases">Panaudojimo atvejai</a></li>
                <li><a href="#benefits">Privalumai</a></li>
                <li><a href="#contact">Kontaktai</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h5>Kontaktai</h5>
              <ul>
                <li>El. paštas: atsiliepsiu@gmail.com</li>
                <li>Tel: +370 633 37939</li>
                <li>Demonstracijai: +370 (5) 200 2623</li>
                <li>Adresas: Vilnius, Lietuva</li>
              </ul>
            </div>

            {/* COMMENTED OUT FOR LEAD GEN
            <div className="footer-section">
              <h5>Pagalba</h5>
              <ul>
                <li><a href="/pagalba">DUK</a></li>
                <li><a href="/prisijungti">Prisijungti</a></li>
                <li><a href="/reset-password">Atkurti slaptažodį</a></li>
              </ul>
            </div>
            */}

            <div className="footer-section">
              <h5>Teisinė informacija</h5>
              <ul>
                <li><a href="/privatumo-politika">Privatumo politika</a></li>
                <li><a href="/naudojimosi-salygos">Naudojimo sąlygos</a></li>
              </ul>
            </div>
          </div>

          <div className="footer-bottom">
            <p>&copy; 2025 Ainora, MB. Visos teisės saugomos.</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default LandingPage;